import { Component, OnInit } from '@angular/core';
import { RegistrationInvite, ToastService, UserInviteForm, UsersInviteService } from 'taxtank-core';
import { BaseFormComponent } from '@shared/component/base/base-form.component';
import { MessagesEnum } from '@client/shared/components/friend-invite/messages.enum';

/**
 * Component with form to invite friend to TaxTank
 * @Todo TT-2095 update component with real API to get invitation link & send data
 */
@Component({
  selector: 'app-friend-invite-dialog',
  templateUrl: './friend-invite-dialog.component.html',
  styleUrls: ['./friend-invite-dialog.component.scss'],
  standalone: false
})
export class FriendInviteDialogComponent extends BaseFormComponent implements OnInit {
  form: UserInviteForm;

  constructor(private usersInviteService: UsersInviteService) {
    super();
  }

  buildForm(): void {
    this.form = new UserInviteForm();
  }

  save(invite: RegistrationInvite): void {
    this.usersInviteService.add(invite).subscribe(() => {
      this.toastService.success(MessagesEnum.FRIEND_INVITED_SUCCESSFULLY);
    });
  }
}
